// extracted by mini-css-extract-plugin
export default {"root":"Image__root___pbR6N"};